


 window.onLoad  = function(){
  var AMap = new AMap.Map('container')
}
var url = 'https://webapi.amap.com/maps?v=1.4.15&key=239a644334581991e20e4adede02e442&callback=onLoad';
var jsapi = document.createElement('script');
jsapi.charset = 'utf-8';
jsapi.src = url;
document.head.appendChild(jsapi)
// import Vue from 'vue';





// WEBPACK FOOTER //
// ./src/utils/location.js